// queries/useGetUserModels.ts
"use client";
import { useInfiniteQuery } from "@tanstack/react-query";
import { fetch } from "libs";
import { GET_USER_MODELS } from "api";
import { ResponseModel } from "types";

const fetchModels = async (
  pageParam: number = 1,
  pageSize: number,
  tags: string[]
): Promise<ResponseModel> => {
  let tagsQueryParams = "";
  if (tags && tags.length > 0) {
    tagsQueryParams = tags.map((tag) => `model_tag=${encodeURIComponent(tag)}`).join("&");
  }

  const queryString = `page=${pageParam}&page_size=${pageSize}${
    tagsQueryParams ? `&${tagsQueryParams}` : ""
  }`;

  return fetch(`${GET_USER_MODELS}?${queryString}`);
};

export const useGetUserModels = (pageSize: number, tags: string[]) => {
  // @ts-expect-error for build
  return useInfiniteQuery<ResponseModel, Error>({
    queryKey: ["models", { pageSize, tags }],
    // @ts-expect-error for build
    queryFn: ({ pageParam = 1 }) => fetchModels(pageParam, pageSize, tags),
    getNextPageParam: (lastPage, allPages) => {
      const nextPage = allPages?.length + 1;
      return nextPage <= Math.ceil(lastPage.total_models / pageSize) ? nextPage : undefined;
    },
  });
};

export default useGetUserModels;
